import React from 'react'
import'./heroText.scss'

const HeroText = () => {
  return (
    <div className="__mw">
      <div className="h_text_wrp">
        <h1>
          Crafted Chocolate for <em>Distinguished Businesses</em>{" "}
        </h1>
        <p>
          We are a B2B-focused artisan chocolate brand creating handcrafted
          collections for hotels, corporates, airlines, cafés, and premium
          retailers. Every piece is made using carefully selected ingredients,
          refined techniques, and strict quality standards to ensure consistency
          at scale.
          <br />
          <br />
          From corporate gifting to hospitality supply and private-label
          solutions, we partner with businesses that value craftsmanship,
          reliability, and exceptional taste.
        </p>
      </div>
    </div>
  );
}

export default HeroText
